import CityPageTemplate from "../city-template/CityPageTemplate";
import { livingstonConfig } from "./data";

export default function LivingstonPage() {
  return <CityPageTemplate config={livingstonConfig} />;
}